module.exports = __webpack_public_path__ + "static/media/coding-class-for-kids.1df9b718.webp";